module.exports = __webpack_public_path__ + "static/media/Lexmark-MX711.1f0be39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Lexmark-MX711.png
// module id = 181
// module chunks = 0